import { useState, useRef, useEffect, useMemo } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";

import VideoThumbnail from "../Assets/Images/video-thumbnail.png";
// import VideoThumbnailMobile from '../Assets/Images/video-thumbnail-mobile.png';
// import PlayButton from '../Assets/Images/play-button.png';
import playBtn from "../Assets/Images/play-btn.png";
import playBtnHovered from "../Assets/Images/play-btn-hover.png";
import Clock from "../Assets/Images/clock.svg";
import Questions from "../Assets/Images/questions.svg";
import Checkmark from "../Assets/Images/checkmark.svg";
import { Close, Pause, PlayArrow } from "@mui/icons-material";
import useWindowDimensions from "../Hooks/useWindowDimensions";
import "../App.scss";
import { Button, CircularProgress } from "@mui/material";
const Start = (props) => {
  const { windowWidth } = useWindowDimensions();

  const [isLoading, setIsLoading] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [searchParams, setSearchParams] = useSearchParams();
  const [isPlayingVideo, setIsPlayingVideo] = useState(false);
  const [isVidPaused, setIsVidPaused] = useState(false);
  const [btnHovered, setBtnHovered] = useState(false);
  // const [startPlaying, setStartPlaying]   = useState(false);
  const [currentTime, setCurrentTime] = useState(0);

  const vidRef = useRef(null);
  const introElmRef = useRef(null);
  const videoElmRef = useRef(null);

  const display = searchParams.get("display");
  const navigate = useNavigate();

  // useEffect(() => {
  //   if(display === "preview") {
  //     console.log("changed background img for embedded preview display...");
  //     document.body.style.background = `#242424 url(${introBgImg}) repeat`;
  //   } else {
  //     document.body.style.background = `#414042`;
  //   }
  // }, [display]);

  function generateRandomHash(length = 16) {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    for (let i = 0; i < length; i++) {
      result += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return result;
  }

  const createAssessment = () => {
    setIsSubmitting(true);
    // TODO: change the pageId according to what the page ID is for this assessment
    const pageId = 1090;

    let leaderId = 0;
    let userId = 0;
    let isMember = false;
    if (searchParams?.get("leader")) {
      leaderId = searchParams?.get("leader");
      userId = searchParams?.get("user");
      isMember = true;
    }

    const email = generateRandomHash() + "@gmail.com";

    const data = {
      assessmentId: process.env.REACT_APP_CLIENT_ID,
      userId: 0,
      userDetails: {
        fullName: " ",
        firstName: " ",
        lastName: " ",
        email: email,
        nameType: "both"
      },
      firstPage: pageId,
      hasParent: false,
      parentId: 0,
      designation: " "
    };

    fetch(process.env.REACT_APP_API_URI + "/v6/user/assessmentAndUser", {
      method: "POST",
      mode: "cors",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        if (data.status === "success") {
          // navigate("/intro/" + data.id + "?" + searchParams, { replace: true });
          navigate(
            "/assessment/" + data.id + "/" + pageId + "?" + searchParams,
            { replace: true }
          );
          console.log("data", data);
        } else {
          // setIsSaving(false);
          // setOpenSnackbar(true);
        }
      })
      .catch((err) => console.error("Failed to create new assessment...", err))
      .finally(() => {
        setIsSubmitting(false);
      });
  };

  const howItWorksLink = () => {
    if (searchParams == "") {
      return "/how-it-works";
    } else {
      return "/how-it-works?" + searchParams;
    }
  };
  // console.log(searchParams.get("display"));

  const assessmentLink = () => {
    return "/assessment?" + searchParams;
  };

  const preAssessmentQuestionsLink = () => {
    navigate("/pre-additional-questions?" + searchParams);
  };

  const introPageLink = () => {
    createAssessment();
    // navigate("/intro/" + id + "?" + searchParams);
  };

  const playVideo = (e) => {
    // if(windowWidth > 830) {
    //   const introElm = introElmRef.current;
    //   const videoElm = videoElmRef.current;

    //   introElm.style.cssText = "width: 0%; padding: 0; overflow: hidden;"
    //   videoElm.style.cssText = "width: 100%; margin: 0 auto; background-color: #E5E5E5; border-radius: 0;";
    //   // if(display === "preview") {
    //   //   videoElm.style.background = `#242424 url(${introBgImg}) repeat`;
    //   // } else videoElm.style.backgroundColor = "#435B63";
    // }
    vidRef.current.play();
    setIsPlayingVideo(true);
    setIsVidPaused(false);
    // if(!startPlaying) {
    //   setStartPlaying(true);
    // }
  };

  const pauseVideo = (e) => {
    // vidRef.current.pause();
    // setPlayingVideo(false);
    vidRef.current.pause();
    setIsVidPaused(true);
    setBtnHovered(false);

    // if(windowWidth > 830) {
    //   const introElm = introElmRef.current;
    //   const videoElm = videoElmRef.current;

    //   introElm.style.cssText = "width: 46%; padding: 0px 3%; overflow: hidden;";
    //   videoElm.style.cssText = "width: 48%; margin: 0 auto; background-color: #435B63; border-top-left-radius: 10px; border-bottom-left-radius: 10px;";
    //   // if(display === "preview") {
    //   //   videoElm.style.background = `#242424 url(${introBgImg}) repeat`;
    //   // } else videoElm.style.backgroundColor = "#435B63";
    // }
    setIsPlayingVideo(false);
  };

  const handlePlayPause = () => {
    if (isPlayingVideo) {
      vidRef.current.pause();
      setIsVidPaused(true);
      setBtnHovered(false);
    } else {
      vidRef.current.play();
      setIsVidPaused(false);
    }
    setIsPlayingVideo(!isPlayingVideo);
  };

  const handleTimeUpdate = () => {
    setCurrentTime(vidRef.current.currentTime);
  };

  const handleSeek = (e) => {
    const newTime = e.target.value;
    vidRef.current.currentTime = newTime;
    setCurrentTime(newTime);
  };

  const handleVideoPlaybackEnd = () => {
    setIsPlayingVideo(false);
    setIsVidPaused(false);

    // if(windowWidth > 830) {
    //   const introElm = introElmRef.current;
    //   const videoElm = videoElmRef.current;

    //   introElm.style.cssText = "width: 46%; padding: 0px 3%; overflow: hidden;";
    //   videoElm.style.cssText = "width: 48%; margin: 0 auto; background-color: #435B63; border-top-left-radius: 10px; border-bottom-left-radius: 10px;";

    //   // if(display === "preview") {
    //   //   videoElm.style.background = `#242424 url(${introBgImg}) repeat`;
    //   // } else videoElm.style.backgroundColor = "#435B63";
    // }
    // showThumbnail();
    showPlayButton();
  };

  const showThumbnail = useMemo(() => {
    if (!isPlayingVideo && !isVidPaused) {
      return (
        <img
          alt="video thumbnail"
          className="thumbnail"
          src={VideoThumbnail}
          style={{ opacity: "1" }}
          // onClick={(e) => pauseVideo(e)}
        />
      );
    } else {
      // return <img alt="video thumbnail" className="thumbnail" src={VideoThumbnail} style={{ opacity: '0' }} onClick={(e) => pauseVideo(e)} />;
      return null;
      // if(startPlaying) {
      //   return null
      // } else {
      //   return <img alt="video thumbnail" className="thumbnail" src={VideoThumbnail} />
      // }
    }
    // }, [isPlayingVideo, startPlaying]);
  }, [isPlayingVideo, isVidPaused]);

  const showPlayButton = () => {
    if (isPlayingVideo) {
      return null;
    } else {
      return (
        <img
          alt="play button"
          className="playbtn"
          src={btnHovered ? playBtnHovered : playBtn}
          onClick={(e) => playVideo(e)}
          onMouseEnter={() => setBtnHovered(true)}
          onMouseLeave={() => setBtnHovered(false)}
        />
      );
    }
  };

  function formatTime(seconds) {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = Math.floor(seconds % 60);
    if (!seconds) return "0:00";
    return `${minutes}:${remainingSeconds < 10 ? "0" : ""}${remainingSeconds}`;
  }

  // const vidsrcURL = "https://40parables-assets.s3.amazonaws.com/bleat-hopeware-strategy-blindspot.mp4";
  // const vidsrcURL = "https://40parables-assets.s3.amazonaws.com/bleat-AI-PulseCheck-Welcome.mp4";
  const vidsrcURL =
    "https://40parables-assets.s3.amazonaws.com/bleat-AI-PulseCheck-Intro.mp4";

  return (
    <div className="container start">
      <div className="intro" ref={introElmRef}>
        {/* <h1 className="intro-heading">
          Is God preparing you for something more?
        </h1> */}
        <p className="intro-subheading">
          This <strong style={{ fontWeight: "900" }}>Gloo Tech Check</strong> <br /><div style={{ height: "3px" }}></div> is a starting
          point to explore:
        </p>
        <div className="intro-points-list">
          <div className="intro-point">
            {" "}
            <img src={Checkmark} alt="checkmark" /> Your approach to using technology in church
          </div>
          <div className="intro-point">
            {" "}
            <img src={Checkmark} alt="checkmark" /> Your opinion about the usage of AI at work
          </div>
          <div className="intro-point">
            {" "}
            <img src={Checkmark} alt="checkmark" /> Your vision of Cottonwood Creek in 2030
          </div>
        </div>
        <Button className="start-btn" onClick={() => introPageLink()}>
          {isSubmitting ? (
            <CircularProgress size={20} style={{ color: "black" }} />
          ) : (
            "GET STARTED"
          )}
        </Button>
        <div className="completion-time-estimate">
          <div className="time-estimate">
            <div className="img-container">
              <img className="clock-icon" src={Clock} alt="estimated time" />
            </div>
            <span>3 minutes</span>
          </div>
          <div className="completion-questions-count">
            <img src={Questions} alt="questions" />
            <span>12 questions</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Start;
